import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { ReactNode } from "react";

type Props = {
	children?: ReactNode;
};

export const LoadingMessage = ({ children }: Props) => {
	const { t } = useResource();
	return (
		<div className="text-muted-foreground text-label">
			{children ?? t(Resources.Modeling.Common.Loading)}
		</div>
	);
};
